<template>
    <transition name="move-message">
        <div :class="[
                prefixCls,
                {
                    [`${prefixCls}-multi-line`]: isMultiLine
                }
            ]" ref="messageItem">
            <span :class="`${prefixCls}-icon`" v-if="type==='error'">
                <svg>
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(-596.000000, -450.000000)" fill="#4C4C4C">
                            <g transform="translate(24.000000, 164.000000)">
                                <g transform="translate(556.000000, 272.000000)">
                                    <g transform="translate(16.000000, 14.000000)">
                                        <path d="M1.6,8 C1.6,6.5232 2.108,5.1656 2.9504,4.0824 L11.9176,13.0496 C10.8336,13.892 9.4768,14.4 8,14.4 C4.4712,14.4 1.6,11.5288 1.6,8 M13.0496,11.9176 L4.0824,2.9504 C5.1664,2.108 6.5232,1.6 8,1.6 C11.5288,1.6 14.4,4.4712 14.4,8 C14.4,9.4768 13.892,10.8344 13.0496,11.9176 M0,8 C0,12.4112 3.5888,16 8,16 C12.4112,16 16,12.4112 16,8 C16,3.5888 12.4112,0 8,0 C3.5888,0 0,3.5888 0,8"
                                            id="Icon"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </span>
            <span :class="`${prefixCls}-icon`" v-if="type==='success'">
                <svg>
                    <defs>
                        <path d="M8,0 C3.5888,0 0,3.5888 0,8 C0,12.4112 3.5888,16 8,16 C12.4112,16 16,12.4112 16,8 C16,3.5888 12.4112,0 8,0 M8,14.4 C4.4712,14.4 1.6,11.5288 1.6,8 C1.6,4.4712 4.4712,1.6 8,1.6 C11.5288,1.6 14.4,4.4712 14.4,8 C14.4,11.5288 11.5288,14.4 8,14.4 M9.8344,5.8344 L7.2,8.4688 L6.1656,7.4344 C5.8528,7.1216 5.3472,7.1216 5.0344,7.4344 C4.7216,7.7472 4.7216,8.2528 5.0344,8.5656 L6.6344,10.1656 C6.7904,10.3216 6.9952,10.4 7.2,10.4 C7.4048,10.4 7.6096,10.3216 7.7656,10.1656 L10.9656,6.9656 C11.2784,6.6528 11.2784,6.1472 10.9656,5.8344 C10.6528,5.5216 10.1472,5.5216 9.8344,5.8344"
                            id="path-1"></path>
                    </defs>
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(-596.000000, -643.000000)">
                            <g transform="translate(24.000000, 164.000000)">
                                <g transform="translate(556.000000, 465.000000)">
                                    <g transform="translate(16.000000, 14.000000)">
                                        <mask fill="white">
                                            <use xlink:href="#path-1"></use>
                                        </mask>
                                        <use fill="#00B39E" xlink:href="#path-1"></use>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </span>
            <span :class="`${prefixCls}-icon`" v-if="type==='warning'">
                <svg>
                    <defs>
                        <path d="M8,0 C3.5888,0 0,3.5888 0,8 C0,12.4112 3.5888,16 8,16 C12.4112,16 16,12.4112 16,8 C16,3.5888 12.4112,0 8,0 M8,14.4 C4.4712,14.4 1.6,11.5288 1.6,8 C1.6,4.4712 4.4712,1.6 8,1.6 C11.5288,1.6 14.4,4.4712 14.4,8 C14.4,11.5288 11.5288,14.4 8,14.4 M8,4 C7.5584,4 7.2,4.3576 7.2,4.8 L7.2,8 C7.2,8.4424 7.5584,8.8 8,8.8 C8.4416,8.8 8.8,8.4424 8.8,8 L8.8,4.8 C8.8,4.3576 8.4416,4 8,4 M8,10.4 C7.5584,10.4 7.2,10.7576 7.2,11.2 C7.2,11.6424 7.5584,12 8,12 C8.4416,12 8.8,11.6424 8.8,11.2 C8.8,10.7576 8.4416,10.4 8,10.4" id="path-1"></path>
                    </defs>
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(-2589.000000, -1017.000000)">
                            <g transform="translate(1760.000000, 164.000000)">
                                <g transform="translate(138.000000, 752.000000)">
                                    <g>
                                        <g transform="translate(230.000000, 89.000000)">
                                            <g transform="translate(445.000000, 0.000000)">
                                                <g transform="translate(16.000000, 12.000000)">
                                                    <mask fill="white">
                                                        <use xlink:href="#path-1"></use>
                                                    </mask>
                                                    <use fill="#FF8B00" xlink:href="#path-1"></use>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </span>
            <div :class="`${prefixCls}-text`"> 
                {{content}}
            </div>
            <div :class="`${prefixCls}-close`"
                @click="close"
                v-if="closeable"> 
                <Icon type="cross"/>
            </div>
        </div>
    </transition>
</template>
<script>
    import Icon from '../icon/'

    const prefixCls = 'yy-message-item'
    export default {
        name: 'YYMessageItem',
        props: {
            type: {
                type: String
            },
            name: {
                type: String,
                required: true
            },
            content: {
                type: String
            },
            duration: {
                type: Number,
                default: 1.5
            },
            closeable: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                prefixCls: prefixCls,
                closeTimer: null,
                isMultiLine: false
            }
        },
        components: {
            Icon
        },
        methods: {
            clearCloseTimer () {
                if (this.closeTimer) {
                    clearTimeout(this.closeTimer)
                    this.closeTimer = null
                }
            },
            close () {
                this.clearCloseTimer()
                this.$parent.close(this.name)
            },
            setIsMultiLine() {
                if(this.$refs.messageItem.offsetHeight > 40) {
                    this.isMultiLine = true
                }
            }
        },
        mounted() {
            this.setIsMultiLine()
            this.clearCloseTimer()
            if (this.duration !== 0) {
                this.closeTimer = setTimeout(() => {
                    this.close()
                }, this.duration * 1000)
            }
        },
        beforeDestroy () {
            this.clearCloseTimer()
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/base/message/message-item.vue